'use-client';
import React from 'react';

export const DomStoreSvg: React.FC<{
  svgId: string;
  role?: string;
}> = ({ svgId, role = 'img' }) => {
  return (
    <svg role={role} className={'ar-' + svgId.replaceAll('.', '-')}>
      <use href={'#' + svgId} width="100%" height="100%" />
    </svg>
  );
};
